import { ClickableRoundedCard } from "../../../Support/Components/ContactCard/ClickableRoundedCard";
import { ReactComponent as LeaderboardsIcon } from "@icons/star.svg";
import { LeaderboardsList } from "../LeaderboardsList/LeaderboardsList";
import { RoundedCard } from "shared/UI/RoundedCard/RoundedCard";
import ViewLoading from "shared/UI/Spinners/ViewLoading";
import { useGetUserLeaderboardsFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { useNavigate } from "react-router-dom";
import { trackCardClicks } from "core/monitoring/Events";
import { useTranslation } from "react-i18next";

export const LeaderboardsSingleCard = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "home.leaderboards" });
  const navigate = useNavigate();
  const { data: userLeaderboards, isLoading, error } = useGetUserLeaderboardsFunctionRequest({}, { showErrorIfStale: false });
  const hasActiveLeaderboards = !isLoading && !error && userLeaderboards && userLeaderboards.active.length > 0;

  const handleClickNoActiveLeaderboard = () => {
    trackCardClicks(t("noActiveLeaderboardsTitle"));
    navigate("/leaderboards");
  };

  if (isLoading && !!userLeaderboards) {
    return (
      <RoundedCard>
        <ViewLoading containerClass="h-full" />
      </RoundedCard>
    );
  }

  return (
    <>
      {!hasActiveLeaderboards && (
        <ClickableRoundedCard
          title={t("noActiveLeaderboardsTitle")}
          icon={<LeaderboardsIcon />}
          description={t("description")}
          handleClick={handleClickNoActiveLeaderboard}
          showChevron
        />
      )}
      {hasActiveLeaderboards && (
        <LeaderboardsList title={t("activeLeaderboardsTitle")} leaderboards={[userLeaderboards.active[0]]} titleNavigatesToAllLeaderboards={true} />
      )}
    </>
  );
};
